var _radialGradient, _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 313.31 60.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.6,44.49l-9.71-23.25-5.42,2.26,9.71,23.25c.56,1.33.56,2.81.01,4.15s-1.59,2.38-2.92,2.94c-2.76,1.15-5.94-.15-7.09-2.91l-9.88-23.62c-1.48-3.49-4.76-5.66-8.55-5.66h0c-3.79,0-7.07,2.17-8.56,5.67l-.16.36-9.72,23.25c-1.15,2.76-4.33,4.06-7.09,2.91-1.33-.56-2.37-1.6-2.92-2.94s-.54-2.81,0-4.15l9.71-23.25-5.41-2.26L.89,44.49c-1.16,2.78-1.17,5.85-.03,8.64s3.31,4.97,6.09,6.13c1.42.59,2.89.87,4.34.87,4.42,0,8.62-2.61,10.43-6.93l7.38-17.65h0l2.49-5.93c.82-1.93,2.62-2.08,3.15-2.08s2.33.15,3.15,2.07l2.5,5.95h0l7.38,17.65c1.81,4.32,6.01,6.93,10.43,6.93,1.45,0,2.92-.28,4.34-.87,2.78-1.16,4.94-3.34,6.09-6.13,1.14-2.79,1.13-5.86-.03-8.64h0Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 45.88,
    cy: -9.19,
    fx: 45.88,
    fy: -9.19,
    r: 84.81,
    gradientTransform: "translate(-5.73 16.28) scale(.87 -.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dd45c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d447c9",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bc4ccf",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9455d9",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5e62e7",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1972f9",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0677ff",
    stopOpacity: 0.5
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 148.55,
    y1: 68.91,
    x2: 142.97,
    y2: 95.94,
    gradientTransform: "translate(-104.02 58.27) rotate(24.36) scale(1.01 -1.07) skewX(-3.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0677ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0677ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 97.65,
    y1: 47.56,
    x2: 92.07,
    y2: 74.59,
    gradientTransform: "translate(-104.02 58.27) rotate(24.36) scale(1.01 -1.07) skewX(-3.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0677ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0677ff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m68.6,44.49l-9.72-23.25-5.4,2.26,9.71,23.25c.56,1.33.56,2.81.01,4.15s-1.59,2.38-2.92,2.94c-2.76,1.15-5.94-.15-7.09-2.91l-9.72-23.25h0l-.16-.37c-1.48-3.49-4.76-5.66-8.55-5.66h0c-3.79,0-7.07,2.17-8.56,5.67l-.15.36h0l-9.72,23.24c-1.15,2.76-4.33,4.06-7.09,2.91-1.33-.56-2.37-1.6-2.92-2.94s-.54-2.81,0-4.15l9.71-23.25-5.41-2.26L.91,44.48c-1.16,2.78-1.17,5.85-.03,8.64s3.31,4.97,6.09,6.13c1.42.59,2.89.87,4.34.87,4.42,0,8.62-2.61,10.43-6.93l7.38-17.65h0l2.49-5.93c.82-1.93,2.62-2.08,3.15-2.08s2.33.15,3.15,2.07l2.5,5.95h0l7.38,17.65c1.81,4.32,6.01,6.93,10.43,6.93,1.45,0,2.92-.28,4.34-.87,2.78-1.16,4.94-3.34,6.09-6.13,1.14-2.79,1.13-5.86-.03-8.64h-.02Z",
    style: {
      fill: "#0677ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75 52.05 19.43 15.37 6.82 45.57 1.4 43.31 19.43 .13 34.75 36.82 50.08 .13 68.1 43.31 62.69 45.57 50.08 15.36 34.75 52.05",
    style: {
      fill: "#0677ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 24.53,
    r: 73.98,
    style: {
      fill: "url(#radial-gradient)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.54,
    y: 21.19,
    width: 17.29,
    height: 30.33,
    style: {
      fill: "url(#linear-gradient)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.57,
    y: 21.19,
    width: 17.29,
    height: 30.33,
    style: {
      fill: "url(#linear-gradient-2)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m224.88,17.38c-6.44,0-11.12,4.85-11.12,11.52s4.89,11.56,11.89,11.56c3.63,0,6.74-1.33,8.77-3.74l.42-.5-2.62-3.01-.58.67c-1.43,1.65-3.47,2.52-5.91,2.52-3.86,0-6.79-2.25-7.45-5.74l-.02-.1h17.63v-.77c0-.15.01-.3.02-.44v-.05c.01-.15.02-.28.02-.4,0-6.68-4.64-11.52-11.04-11.52h-.01Zm-6.61,9.51l.02-.1c.66-3.29,3.25-5.41,6.59-5.41s5.97,2.12,6.63,5.41l.02.1h-13.27.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.83,17.38c-6.44,0-11.12,4.85-11.12,11.52s4.89,11.56,11.89,11.56c3.63,0,6.74-1.33,8.77-3.74l.42-.5-2.62-3.01-.58.67c-1.43,1.65-3.47,2.52-5.91,2.52-3.86,0-6.79-2.25-7.45-5.74l-.02-.1h17.63v-.77c0-.15,0-.3.02-.44v-.05c0-.15.02-.28.02-.4,0-6.68-4.64-11.52-11.04-11.52h-.01Zm-6.61,9.51l.02-.1c.66-3.29,3.25-5.41,6.59-5.41s5.97,2.12,6.63,5.41l.02.1h-13.27,0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.82,17.38c-6.44,0-11.12,4.85-11.12,11.52s4.89,11.56,11.89,11.56c3.63,0,6.74-1.33,8.77-3.74l.42-.5-2.62-3.01-.58.67c-1.43,1.65-3.47,2.52-5.91,2.52-3.86,0-6.79-2.25-7.45-5.74l-.02-.1h17.63v-.77c0-.15.01-.3.02-.44v-.05c.01-.15.02-.28.02-.4,0-6.68-4.64-11.52-11.04-11.52h-.01Zm-6.61,9.51l.02-.1c.66-3.29,3.25-5.41,6.59-5.41s5.97,2.12,6.63,5.41l.02.1h-13.27.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.61,28.83v11.17h-4.47v-11.17c0-3.08,1.09-5.72,3.27-7.9s4.82-3.27,7.9-3.27v4.47c-1.85,0-3.43.66-4.74,1.97s-1.97,2.89-1.97,4.74h.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.71,17.58c-3.15,0-5.87,1.13-8.1,3.36-2.23,2.23-3.36,4.95-3.36,8.1s1.13,5.87,3.36,8.1c2.23,2.23,4.95,3.36,8.1,3.36s5.87-1.13,8.1-3.36c2.23-2.23,3.35-4.95,3.35-8.1V10.9h-4.44v9.06l-.14-.11c-1.96-1.5-4.27-2.27-6.87-2.27h0Zm4.95,16.41c-1.36,1.36-3.03,2.06-4.95,2.06s-3.59-.69-4.95-2.06c-1.37-1.36-2.06-3.03-2.06-4.95s.69-3.59,2.06-4.95c1.36-1.36,3.03-2.06,4.95-2.06s3.59.69,4.95,2.06c1.37,1.36,2.06,3.03,2.06,4.95s-.69,3.59-2.06,4.95Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.29,21.04c-2.19-2.19-4.84-3.29-7.94-3.29s-5.75,1.1-7.94,3.29c-2.2,2.19-3.29,4.84-3.29,7.94s1.1,5.75,3.29,7.94c2.19,2.19,4.84,3.29,7.94,3.29,2.56,0,4.81-.74,6.74-2.22v2.22h4.49v-11.24c0-3.1-1.1-5.75-3.29-7.94h0Zm-3.18,12.71c-1.32,1.32-2.91,1.98-4.76,1.98s-3.45-.66-4.76-1.98c-1.32-1.32-1.98-2.91-1.98-4.76s.66-3.45,1.98-4.76,2.91-1.98,4.76-1.98,3.45.66,4.76,1.98c1.32,1.32,1.98,2.91,1.98,4.76s-.66,3.45-1.98,4.76Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.95,
    y: 17.73,
    width: 4.37,
    height: 22.44,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.13,
    cy: 12.68,
    r: 2.52,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.24,17.66h12.24v4.47h-12.24c-.61,0-1.14.22-1.58.66s-.66.96-.66,1.58.22,1.14.66,1.58.96.66,1.58.66h5.53c1.85,0,3.43.66,4.74,1.97s1.97,2.89,1.97,4.74-.66,3.43-1.97,4.74-2.89,1.97-4.74,1.97h-12.24v-4.47h12.24c.61,0,1.14-.22,1.58-.66s.66-.96.66-1.58-.22-1.14-.66-1.58-.96-.66-1.58-.66h-5.53c-1.85,0-3.43-.65-4.74-1.97-1.31-1.31-1.97-2.89-1.97-4.74s.66-3.43,1.97-4.74,2.89-1.97,4.74-1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.05 31.73 195.8 17.7 191 17.7 203.04 40.98 215.18 17.7 210.37 17.7 203.05 31.73",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.18,
    cy: 15.33,
    r: 1.12,
    style: {
      fill: "#dd45c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.8,
    cy: 25.79,
    r: 1.2,
    style: {
      fill: "#dd45c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.62,25.97c-.84.64-1.82.97-2.93.97-1.35,0-2.5-.48-3.45-1.43s-1.43-2.1-1.43-3.45.48-2.5,1.43-3.45c.95-.95,2.1-1.43,3.45-1.43s2.5.48,3.45,1.43,1.43,2.1,1.43,3.45v4.88h-1.95v-.97Zm-2.93-6.84c-.81,0-1.5.29-2.07.86s-.86,1.26-.86,2.07.29,1.5.86,2.07,1.26.86,2.07.86,1.5-.29,2.07-.86.86-1.26.86-2.07-.29-1.5-.86-2.07-1.26-.86-2.07-.86Z",
    style: {
      fill: "#dd45c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.23,
    y: 17.17,
    width: 1.9,
    height: 9.75,
    style: {
      fill: "#dd45c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.51,17.36c-2.6,0-4.93,1.14-6.55,2.93-1.62-1.79-3.95-2.93-6.55-2.93-4.87,0-8.83,3.96-8.83,8.83v13.94h4.55v-13.94c0-2.36,1.92-4.28,4.28-4.28s4.27,1.91,4.27,4.26h0v13.95h4.55v-13.94h0c0-2.36,1.92-4.27,4.27-4.27s4.28,1.92,4.28,4.28v13.94h4.55v-13.94c0-4.87-3.96-8.83-8.83-8.83h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvLogoWhite);
export default __webpack_public_path__ + "static/media/mv_logo_white.f4a343a436217a6efdaf176ca19e23da.svg";
export { ForwardRef as ReactComponent };